"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CalendarOptionButton = function CalendarOptionButton(_ref) {
  var linkProps = _ref.linkProps,
      icon = _ref.icon,
      calendarName = _ref.calendarName,
      _ref$onMount = _ref.onMount,
      onMount = _ref$onMount === void 0 ? function () {} : _ref$onMount;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Icon = _UX2$Element.Icon,
      Link = _UX2$Element.Link,
      Block = _UX2$Element.Block,
      Details = _UX2$Element.Details;
  var styles = {
    container: {
      flexBasis: '33%',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'section',
      borderRadius: '5px',
      maxWidth: '120px',
      marginRight: 'xsmall',
      ':last-child': {
        marginRight: 0
      }
    },
    link: {
      display: 'block',
      paddingVertical: 'xxsmall'
    },
    content: {
      textAlign: 'center',
      color: 'inherit'
    }
  };
  (0, _react.useEffect)(function () {
    onMount();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(Link, _extends({}, linkProps, {
    style: styles.link
  }), /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.content
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    icon: icon
  })), /*#__PURE__*/_react["default"].createElement(Details, {
    style: styles.content
  }, calendarName)));
};

CalendarOptionButton.propTypes = {
  linkProps: _propTypes["default"].shape({
    href: _propTypes["default"].string.isRequired,
    target: _propTypes["default"].string
  }).isRequired,
  icon: _propTypes["default"].string.isRequired,
  calendarName: _propTypes["default"].string,
  onMount: _propTypes["default"].func
};
var _default = CalendarOptionButton;
exports["default"] = _default;